import React, { useEffect, useState } from "react";
import {useParams } from "react-router-dom";
import Noimage from "../../images/3.png";
import { FaShareAlt } from "react-icons/fa";
import { Divider } from "primereact/divider";

function TabviewAllProducts() {
  const productId = sessionStorage.getItem("productId");

  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  async function fetchProductDetails() {
    try {
      const res = await fetch(`/allCarsByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setProduct(data);
    } catch (err) {
      console.error("Product fetch error:", err.message);
    }
  }

  async function fetchProductImages() {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Media not in array format");
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Image fetch error:", err.message);
    }
  }

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  function handleShare(product) {
    const shareText = `Check out this product: ${product.productName}, Price: ₹${product.price}`;
    const shareUrl = `${window.location.origin}/product/${product.productID}`;

    if (navigator.share) {
      navigator
        .share({
          title: product.productName,
          text: shareText,
          url: shareUrl,
        })
        .then(() => console.log("Product shared successfully"))
        .catch((error) => console.error("Error sharing", error));
    } else {
      // Fallback: copy URL to clipboard
      navigator.clipboard.writeText(shareUrl).then(() => {
        alert("Product link copied to clipboard. Share it anywhere!");
      });
    }
  }

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px 30px",
    width: "100%",
  };

  const renderSpec = (label, value) => {
    if (value === undefined || value === null || value === "") return null;
    return (
      <div style={{ display: "flex" }}>
        <strong style={{ width: "180px" }}>{label}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  const sectionHeadingStyle = {
    marginTop: "20px",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#36c2c2",
    borderBottom: "1px solid #ccc",
    paddingBottom: "5px",
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          // maxWidth: "1200px",
          margin: "50px 50px",
          padding: "20px",
          flexWrap: "wrap",
          gap: "20px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          borderRadius: "12px",
        }}>
        {/* Left: Image Thumbnails */}
        <div style={{ width: "80px" }}>
          {productImg.map((img, idx) => (
            <img
              key={idx}
              src={
                img.productImages
                  ? `data:image/png;base64,${img.productImages}`
                  : Noimage
              }
              alt="Thumbnail"
              onClick={() => handleThumbnailClick(img)}
              style={{
                width: "100%",
                border: mainImage.includes(img.productImages)
                  ? "2px solid #ff6600"
                  : "1px solid #ccc",
                borderRadius: "10px",
                marginBottom: "10px",
                cursor: "pointer",
                padding: "2px",
                transition: "transform 0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          ))}
        </div>

        {/* Center: Main Image */}
        <div style={{ flex: "1 1 40%", minWidth: "250px" }}>
          <img
            src={mainImage || Noimage}
            alt="Main Product"
            style={{
              width: "100%",
              borderRadius: "12px",
              border: "1px solid #ddd",
              objectFit: "cover",
              maxHeight: "450px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>

        {/* Right: Product Info */}
        <div style={{ flex: "1 1 40%", minWidth: "250px" }}>
          {product.map((prdct) => (
            <div key={prdct.productID}>
              <h2
                style={{
                  fontSize: "24px",
                  color: "#333",
                  marginBottom: "10px",
                }}>
                {prdct.productName}
              </h2>
              <p>
                <strong style={{ color: "#555" }}>Price:</strong>{" "}
                <span style={{ color: "#e60000", fontSize: "18px" }}>
                  ₹{prdct.price}
                </span>
              </p>
              <p>
                <strong>Color:</strong> {prdct.color}
              </p>
              <p>
                <strong>Age Group:</strong> {prdct.ageGroup}
              </p>
              <p>
                <strong>Brand:</strong> {prdct.brand}
              </p>

              <a
                href={`https://wa.me/919490384177?text=Hi, I'm interested in buying the product: ${encodeURIComponent(
                  prdct.productName
                )}, Price: ₹${prdct.price}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  marginTop: "30px",
                  backgroundColor: "#25D366",
                  color: "white",
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "30px",
                  textDecoration: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#1DA851")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#25D366")
                }>
                Shop on WhatsApp
              </a>

              <button
                onClick={() => handleShare(prdct)}
                style={{
                  marginTop: "20px",
                  marginLeft: "10px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  padding: "12px 16px",
                  fontSize: "16px",
                  borderRadius: "50%",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                }}
                title="Share Product">
                <FaShareAlt />
              </button>
            </div>
          ))}
        </div>
      </div>
      {/* Description and Specifications - Below main flex container */}
      <Divider></Divider>
      <div className="ml-6 mr-6">
        {product.map((prdct) => (
          <div key={`desc-spec-${prdct.productID}`}>
            <div></div>

            <div style={{ margin: "20px" }}>
              <h4 style={{ marginBottom: "15px" }}>Specifications</h4>

              {/* Group: General */}
              <h5 style={sectionHeadingStyle}>General</h5>
              <div style={gridStyle}>
                {renderSpec("Type", prdct.type)}
                {renderSpec("Model Number", prdct.modelNumber)}
                {renderSpec("Color", prdct.color)}
                {renderSpec("Speed", prdct.speed)}
                {renderSpec("Weight", prdct.weight)}
                {renderSpec("Country of Origin", prdct.countryOfOrigin)}
                {renderSpec("Manufacturer", prdct.manufacturer)}
              </div>

              {/* Group: Power Features */}
              <h5 style={sectionHeadingStyle}>Power Features</h5>
              <div style={gridStyle}>
                {renderSpec("Battery Type", prdct.batteryType)}
                {renderSpec(
                  "Battery Included",
                  prdct.batteryIncluded ? "Yes" : "No"
                )}
                {renderSpec("Rechargeable", prdct.rechargeable ? "Yes" : "No")}
              </div>

              {/* Group: Convenience Features */}
              <h5 style={sectionHeadingStyle}>Convenience Features</h5>
              <div style={gridStyle}>
                {renderSpec(
                  "Parental Remote",
                  prdct.parentalRemote ? "Yes" : "No"
                )}
                {renderSpec(
                  "MP3 Player Supported",
                  prdct.mpThreePlayerSupported ? "Yes" : "No"
                )}
                {renderSpec(
                  "Other Convenience Features",
                  prdct.otherConvenienceFeatures
                )}
              </div>

              {/* Group: Dimensions */}
              <h5 style={sectionHeadingStyle}>Dimensions</h5>
              <div style={gridStyle}>
                {renderSpec("Dimensions", prdct.dimentions)}
                {renderSpec("Maximum User Weight", prdct.maximumUserWeight)}
              </div>

              {/* Group: Warranty */}
              <h5 style={sectionHeadingStyle}>Warranty</h5>
              <div style={gridStyle}>
                {renderSpec("Warranty", prdct.warrenty)}
                {renderSpec("Covered in Warranty", prdct.coveredInWarranty)}
                {renderSpec(
                  "Not Covered in Warranty",
                  prdct.notCoveredInWarranty
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default TabviewAllProducts;
